import { Empty, Typography, Space } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Title, Text, Paragraph } = Typography;

const EmptyAsset = () => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        textAlign: 'center',
        padding: '20px',
        maxWidth: '650px',
        margin: '0 auto',
      }}
    >
      <Empty
        description={
          <Title level={4}>{t('assetsModal.emptyAsset.title')}</Title>
        }
      />

      <div
        style={{
          background: '#f5f5f5',
          padding: '15px 20px',
          borderRadius: '8px',
          border: '1px solid #e8e8e8',
          textAlign: 'left',
        }}
      >
        <Space align="start">
          <InfoCircleOutlined
            style={{ color: '#1890ff', fontSize: '16px', marginTop: '4px' }}
          />
          <div>
            <Text strong style={{ display: 'block', marginBottom: '8px' }}>
              {t('assetsModal.emptyAsset.howToAdd')}
            </Text>

            <ul style={{ paddingLeft: '20px', margin: '0' }}>
              <li style={{ marginBottom: '8px' }}>
                <Text strong>
                  {t('assetsModal.emptyAsset.myAssets.label')}:
                </Text>{' '}
                {t('assetsModal.emptyAsset.myAssets.desc')}
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Text strong>
                  {t('assetsModal.emptyAsset.stockMedia.label')}:
                </Text>{' '}
                {t('assetsModal.emptyAsset.stockMedia.desc')}
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Text strong>{t('assetsModal.emptyAsset.aiMedia.label')}:</Text>{' '}
                {t('assetsModal.emptyAsset.aiMedia.desc')}
              </li>
              <li>
                <Text strong>{t('assetsModal.emptyAsset.upload.label')}:</Text>{' '}
                {t('assetsModal.emptyAsset.upload.desc')}
              </li>
            </ul>

            <Paragraph
              type="secondary"
              style={{ marginTop: '12px', fontSize: '13px' }}
            >
              {t('assetsModal.emptyAsset.hint')}
            </Paragraph>
          </div>
        </Space>
      </div>
    </div>
  );
};

export default EmptyAsset;
